import NotificationDisableModal from './NotificationDisableModal';

export default NotificationDisableModal;
